import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { charCodeAt1yspne1d8erbm as charCodeAt } from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  toString22rbkbhdb5cl2 as toString,
  Char__toInt_impl_vasixdnyockrdnmht5 as Char__toInt_impl_vasixd,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { equals2v6cggk171b6e as equals } from '../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { AbstractMutableSetthfi6jds1k2h as AbstractMutableSet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/AbstractMutableSet.mjs';
import { AbstractMutableCollections0bg6c40ztuj as AbstractMutableCollection } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/AbstractMutableCollectionJs.mjs';
import {
  MutableEntry12w2i19w0igk5 as MutableEntry,
  Entry2xmjmyutzoq3p as Entry,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  equals2au1ep9vhcato as equals_0,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString_0,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  fill3hcjvebk42tyx as fill,
  fill2542d4m9l93pn as fill_0,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function advance($this) {
  $l$loop: while ($this.i4n_1 < $this.k4n_1.p4n_1) {
    var idx = $this.k4n_1.o4n_1[$this.i4n_1];
    if (idx >= 0 && !($this.k4n_1.l4n_1[idx] == null))
      break $l$loop;
    $this.i4n_1 = $this.i4n_1 + 1 | 0;
  }
}
var CaseInsensitiveMap$KeySet$iterator$1Class;
function CaseInsensitiveMap$KeySet$iterator$1() {
  if (CaseInsensitiveMap$KeySet$iterator$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.k4n_1 = this$0;
        this.i4n_1 = 0;
        this.j4n_1 = null;
        advance(this);
      }
      q1() {
        return this.i4n_1 < this.k4n_1.p4n_1;
      }
      r1() {
        if (!this.q1())
          throw NoSuchElementException().t6();
        var idx = this.k4n_1.o4n_1[this.i4n_1];
        this.j4n_1 = ensureNotNull(this.k4n_1.l4n_1[idx]);
        this.i4n_1 = this.i4n_1 + 1 | 0;
        advance(this);
        return ensureNotNull(this.j4n_1);
      }
      p6() {
        var tmp0_elvis_lhs = this.j4n_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw IllegalStateException().o('next() must be called before remove()');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var key = tmp;
        this.k4n_1.t4n(key);
        this.j4n_1 = null;
      }
    }
    initMetadataForClass($);
    CaseInsensitiveMap$KeySet$iterator$1Class = $;
  }
  return CaseInsensitiveMap$KeySet$iterator$1Class;
}
function advance_0($this) {
  $l$loop: while ($this.u4n_1 < $this.w4n_1.p4n_1) {
    var idx = $this.w4n_1.o4n_1[$this.u4n_1];
    if (idx >= 0 && !($this.w4n_1.l4n_1[idx] == null))
      break $l$loop;
    $this.u4n_1 = $this.u4n_1 + 1 | 0;
  }
}
var CaseInsensitiveMap$ValueCollection$iterator$1Class;
function CaseInsensitiveMap$ValueCollection$iterator$1() {
  if (CaseInsensitiveMap$ValueCollection$iterator$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.w4n_1 = this$0;
        this.u4n_1 = 0;
        this.v4n_1 = null;
        advance_0(this);
      }
      q1() {
        return this.u4n_1 < this.w4n_1.p4n_1;
      }
      r1() {
        if (!this.q1())
          throw NoSuchElementException().t6();
        var idx = this.w4n_1.o4n_1[this.u4n_1];
        this.v4n_1 = ensureNotNull(this.w4n_1.l4n_1[idx]);
        var tmp = this.w4n_1.m4n_1[idx];
        var result = !(tmp == null) ? tmp : THROW_CCE();
        this.u4n_1 = this.u4n_1 + 1 | 0;
        advance_0(this);
        return result;
      }
      p6() {
        var tmp0_elvis_lhs = this.v4n_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw IllegalStateException().o('next() must be called before remove()');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var key = tmp;
        this.w4n_1.t4n(key);
        this.v4n_1 = null;
      }
    }
    initMetadataForClass($);
    CaseInsensitiveMap$ValueCollection$iterator$1Class = $;
  }
  return CaseInsensitiveMap$ValueCollection$iterator$1Class;
}
function advance_1($this) {
  $l$loop: while ($this.x4n_1 < $this.z4n_1.p4n_1) {
    var idx = $this.z4n_1.o4n_1[$this.x4n_1];
    if (idx >= 0 && !($this.z4n_1.l4n_1[idx] == null))
      break $l$loop;
    $this.x4n_1 = $this.x4n_1 + 1 | 0;
  }
}
var CaseInsensitiveMap$EntrySet$iterator$1Class;
function CaseInsensitiveMap$EntrySet$iterator$1() {
  if (CaseInsensitiveMap$EntrySet$iterator$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.z4n_1 = this$0;
        this.x4n_1 = 0;
        this.y4n_1 = null;
        advance_1(this);
      }
      q1() {
        return this.x4n_1 < this.z4n_1.p4n_1;
      }
      r1() {
        if (!this.q1())
          throw NoSuchElementException().t6();
        var idx = this.z4n_1.o4n_1[this.x4n_1];
        this.y4n_1 = ensureNotNull(this.z4n_1.l4n_1[idx]);
        var tmp = ensureNotNull(this.y4n_1);
        var tmp_0 = this.z4n_1.m4n_1[idx];
        var entry = new (MapEntry())(this.z4n_1, tmp, !(tmp_0 == null) ? tmp_0 : THROW_CCE());
        this.x4n_1 = this.x4n_1 + 1 | 0;
        advance_1(this);
        return entry;
      }
      p6() {
        var tmp0_elvis_lhs = this.y4n_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw IllegalStateException().o('next() must be called before remove()');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var key = tmp;
        this.z4n_1.t4n(key);
        this.y4n_1 = null;
      }
    }
    initMetadataForClass($);
    CaseInsensitiveMap$EntrySet$iterator$1Class = $;
  }
  return CaseInsensitiveMap$EntrySet$iterator$1Class;
}
function caseInsensitiveHashCode($this, s) {
  var h = 0;
  var inductionVariable = 0;
  var last = s.length;
  if (inductionVariable < last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = imul(31, h);
      // Inline function 'kotlin.text.lowercaseChar' call
      // Inline function 'kotlin.text.lowercase' call
      var this_0 = charCodeAt(s, i);
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp$ret$1 = toString(this_0).toLowerCase();
      // Inline function 'kotlin.code' call
      var this_1 = charCodeAt(tmp$ret$1, 0);
      h = tmp + Char__toInt_impl_vasixd(this_1) | 0;
    }
     while (inductionVariable < last);
  return h;
}
function putWithoutTrackingOrderReturnIndex($this, key, value) {
  var hash = caseInsensitiveHashCode(Companion_getInstance(), key);
  var index = hash & ($this.l4n_1.length - 1 | 0);
  while (true) {
    var existingKey = $this.l4n_1[index];
    if (existingKey == null) {
      $this.l4n_1[index] = key;
      $this.m4n_1[index] = value;
      $this.n4n_1 = $this.n4n_1 + 1 | 0;
      return index;
    }
    if (equals(existingKey, key, true)) {
      $this.m4n_1[index] = value;
      return index;
    }
    index = (index + 1 | 0) & ($this.l4n_1.length - 1 | 0);
  }
}
function findIndex($this, key) {
  if ($this.n4n_1 === 0)
    return -1;
  var hash = caseInsensitiveHashCode(Companion_getInstance(), key);
  var index = hash & ($this.l4n_1.length - 1 | 0);
  while (true) {
    var existingKey = $this.l4n_1[index];
    if (existingKey == null)
      return -1;
    if (equals(existingKey, key, true))
      return index;
    index = (index + 1 | 0) & ($this.l4n_1.length - 1 | 0);
  }
}
function ensureCapacity($this) {
  if (imul($this.n4n_1, 4) >= imul($this.l4n_1.length, 3)) {
    resize($this, imul($this.l4n_1.length, 2));
  }
}
function resize($this, newCapacity) {
  var oldKeys = $this.l4n_1;
  var oldValues = $this.m4n_1;
  var oldInsertionOrder = $this.o4n_1;
  var oldInsertionCount = $this.p4n_1;
  var tmp = $this;
  // Inline function 'kotlin.arrayOfNulls' call
  tmp.l4n_1 = Array(newCapacity);
  var tmp_0 = $this;
  // Inline function 'kotlin.arrayOfNulls' call
  tmp_0.m4n_1 = Array(newCapacity);
  var tmp_1 = $this;
  var tmp_2 = 0;
  var tmp_3 = new Int32Array(newCapacity);
  while (tmp_2 < newCapacity) {
    tmp_3[tmp_2] = -1;
    tmp_2 = tmp_2 + 1 | 0;
  }
  tmp_1.o4n_1 = tmp_3;
  $this.n4n_1 = 0;
  $this.p4n_1 = 0;
  var inductionVariable = 0;
  if (inductionVariable < oldInsertionCount)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var oldIndex = oldInsertionOrder[i];
      if (oldIndex >= 0 && !(oldKeys[oldIndex] == null)) {
        var tmp_4 = ensureNotNull(oldKeys[oldIndex]);
        var tmp_5 = oldValues[oldIndex];
        $this.a4o(tmp_4, !(tmp_5 == null) ? tmp_5 : THROW_CCE());
      }
    }
     while (inductionVariable < oldInsertionCount);
}
function compactInsertionOrder($this) {
  if ($this.p4n_1 === 0)
    return Unit_instance;
  var writeIndex = 0;
  var inductionVariable = 0;
  var last = $this.p4n_1;
  if (inductionVariable < last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var idx = $this.o4n_1[i];
      if (idx >= 0 && !($this.l4n_1[idx] == null)) {
        var tmp = $this.o4n_1;
        var _unary__edvuaz = writeIndex;
        writeIndex = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = idx;
      }
    }
     while (inductionVariable < last);
  var inductionVariable_0 = writeIndex;
  var last_0 = $this.o4n_1.length;
  if (inductionVariable_0 < last_0)
    do {
      var i_0 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      $this.o4n_1[i_0] = -1;
    }
     while (inductionVariable_0 < last_0);
  $this.p4n_1 = writeIndex;
}
var KeySetClass;
function KeySet() {
  if (KeySetClass === VOID) {
    class $ extends AbstractMutableSet() {
      static c4o($outer, $box) {
        if ($box === VOID)
          $box = {};
        $box.b4o_1 = $outer;
        return this.b8($box);
      }
      q2() {
        return this.b4o_1.n4n_1;
      }
      d4o(element) {
        throw UnsupportedOperationException().a1('CaseInsensitiveMap.keys does not support add');
      }
      i2(element) {
        return this.d4o((!(element == null) ? typeof element === 'string' : false) ? element : THROW_CCE());
      }
      e4o(element) {
        return this.b4o_1.j2o(element);
      }
      t2(element) {
        if (!(!(element == null) ? typeof element === 'string' : false))
          return false;
        return this.e4o((!(element == null) ? typeof element === 'string' : false) ? element : THROW_CCE());
      }
      p1() {
        return new (CaseInsensitiveMap$KeySet$iterator$1())(this.b4o_1);
      }
    }
    initMetadataForClass($, 'KeySet');
    KeySetClass = $;
  }
  return KeySetClass;
}
var ValueCollectionClass;
function ValueCollection() {
  if (ValueCollectionClass === VOID) {
    class $ extends AbstractMutableCollection() {
      static g4o($outer, $box) {
        if ($box === VOID)
          $box = {};
        $box.f4o_1 = $outer;
        return this.m6($box);
      }
      q2() {
        return this.f4o_1.n4n_1;
      }
      h4o(element) {
        throw UnsupportedOperationException().a1('CaseInsensitiveMap.values does not support add');
      }
      i2(element) {
        return this.h4o(!(element == null) ? element : THROW_CCE());
      }
      p1() {
        return new (CaseInsensitiveMap$ValueCollection$iterator$1())(this.f4o_1);
      }
    }
    initMetadataForClass($, 'ValueCollection');
    ValueCollectionClass = $;
  }
  return ValueCollectionClass;
}
var EntrySetClass;
function EntrySet() {
  if (EntrySetClass === VOID) {
    class $ extends AbstractMutableSet() {
      static j4o($outer, $box) {
        if ($box === VOID)
          $box = {};
        $box.i4o_1 = $outer;
        return this.b8($box);
      }
      q2() {
        return this.i4o_1.n4n_1;
      }
      k4o(element) {
        throw UnsupportedOperationException().a1('CaseInsensitiveMap.entries does not support add');
      }
      i2(element) {
        return this.k4o((!(element == null) ? isInterface(element, MutableEntry()) : false) ? element : THROW_CCE());
      }
      p1() {
        return new (CaseInsensitiveMap$EntrySet$iterator$1())(this.i4o_1);
      }
    }
    initMetadataForClass($, 'EntrySet');
    EntrySetClass = $;
  }
  return EntrySetClass;
}
var MapEntryClass;
function MapEntry() {
  if (MapEntryClass === VOID) {
    class $ {
      constructor($outer, key, _value) {
        this.n4o_1 = $outer;
        this.l4o_1 = key;
        this.m4o_1 = _value;
      }
      m3() {
        return this.l4o_1;
      }
      n3() {
        return this.m4o_1;
      }
      equals(other) {
        if (!(!(other == null) ? isInterface(other, Entry()) : false))
          return false;
        return equals_0(this.l4o_1, other.m3()) && equals_0(this.n3(), other.n3());
      }
      hashCode() {
        return getStringHashCode(this.l4o_1) ^ hashCode(this.n3());
      }
      toString() {
        return this.l4o_1 + '=' + toString_0(this.n3());
      }
    }
    initMetadataForClass($, 'MapEntry', VOID, VOID, [MutableEntry()]);
    MapEntryClass = $;
  }
  return MapEntryClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.o4o_1 = 8;
        var tmp = this;
        // Inline function 'kotlin.emptyArray' call
        tmp.p4o_1 = [];
        var tmp_0 = this;
        // Inline function 'kotlin.emptyArray' call
        tmp_0.q4o_1 = [];
        this.r4o_1 = new Int32Array(0);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var CaseInsensitiveMapClass;
function CaseInsensitiveMap() {
  if (CaseInsensitiveMapClass === VOID) {
    class $ {
      constructor() {
        Companion_getInstance();
        this.l4n_1 = Companion_getInstance().p4o_1;
        this.m4n_1 = Companion_getInstance().q4o_1;
        this.n4n_1 = 0;
        this.o4n_1 = Companion_getInstance().r4o_1;
        this.p4n_1 = 0;
        this.q4n_1 = null;
        this.r4n_1 = null;
        this.s4n_1 = null;
      }
      q2() {
        return this.n4n_1;
      }
      j2o(key) {
        return findIndex(this, key) >= 0;
      }
      s4(key) {
        if (!(!(key == null) ? typeof key === 'string' : false))
          return false;
        return this.j2o((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
      }
      k2o(key) {
        var index = findIndex(this, key);
        return index >= 0 ? this.m4n_1[index] : null;
      }
      u4(key) {
        if (!(!(key == null) ? typeof key === 'string' : false))
          return null;
        return this.k2o((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
      }
      n1() {
        return this.n4n_1 === 0;
      }
      a5() {
        if (this.n4n_1 > 0) {
          fill(this.l4n_1, null);
          fill(this.m4n_1, null);
          fill_0(this.o4n_1, -1);
          this.n4n_1 = 0;
          this.p4n_1 = 0;
        }
      }
      a4o(key, value) {
        if (this.l4n_1 === Companion_getInstance().p4o_1) {
          var tmp = this;
          // Inline function 'kotlin.arrayOfNulls' call
          tmp.l4n_1 = Array(8);
          var tmp_0 = this;
          // Inline function 'kotlin.arrayOfNulls' call
          tmp_0.m4n_1 = Array(8);
          var tmp_1 = this;
          var tmp_2 = 0;
          var tmp_3 = new Int32Array(8);
          while (tmp_2 < 8) {
            tmp_3[tmp_2] = -1;
            tmp_2 = tmp_2 + 1 | 0;
          }
          tmp_1.o4n_1 = tmp_3;
        }
        var hash = caseInsensitiveHashCode(Companion_getInstance(), key);
        var index = hash & (this.l4n_1.length - 1 | 0);
        while (true) {
          var existingKey = this.l4n_1[index];
          if (existingKey == null) {
            ensureCapacity(this);
            index = hash & (this.l4n_1.length - 1 | 0);
            while (!(this.l4n_1[index] == null)) {
              index = (index + 1 | 0) & (this.l4n_1.length - 1 | 0);
            }
            if (this.p4n_1 === this.o4n_1.length) {
              compactInsertionOrder(this);
            }
            this.l4n_1[index] = key;
            this.m4n_1[index] = value;
            var tmp_4 = this.o4n_1;
            var _unary__edvuaz = this.p4n_1;
            this.p4n_1 = _unary__edvuaz + 1 | 0;
            tmp_4[_unary__edvuaz] = index;
            this.n4n_1 = this.n4n_1 + 1 | 0;
            return null;
          }
          if (equals(existingKey, key, true)) {
            var oldValue = this.m4n_1[index];
            this.m4n_1[index] = value;
            return oldValue;
          }
          index = (index + 1 | 0) & (this.l4n_1.length - 1 | 0);
        }
      }
      x4(key, value) {
        var tmp = (!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE();
        return this.a4o(tmp, !(value == null) ? value : THROW_CCE());
      }
      s4o(from) {
        // Inline function 'kotlin.collections.forEach' call
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s = from.l3().p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          // Inline function 'kotlin.collections.component1' call
          var key = element.m3();
          // Inline function 'kotlin.collections.component2' call
          var value = element.n3();
          this.a4o(key, value);
        }
      }
      z4(from) {
        return this.s4o(from);
      }
      t4n(key) {
        var index = findIndex(this, key);
        if (index < 0)
          return null;
        var oldValue = this.m4n_1[index];
        var inductionVariable = 0;
        var last = this.p4n_1;
        if (inductionVariable < last)
          $l$loop: do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (this.o4n_1[i] === index) {
              this.o4n_1[i] = -1;
              break $l$loop;
            }
          }
           while (inductionVariable < last);
        this.l4n_1[index] = null;
        this.m4n_1[index] = null;
        this.n4n_1 = this.n4n_1 - 1 | 0;
        var nextIndex = (index + 1 | 0) & (this.l4n_1.length - 1 | 0);
        while (!(this.l4n_1[nextIndex] == null)) {
          var rehashKey = ensureNotNull(this.l4n_1[nextIndex]);
          var rehashValue = this.m4n_1[nextIndex];
          var oldRehashIndex = nextIndex;
          this.l4n_1[nextIndex] = null;
          this.m4n_1[nextIndex] = null;
          this.n4n_1 = this.n4n_1 - 1 | 0;
          var newIndex = putWithoutTrackingOrderReturnIndex(this, rehashKey, !(rehashValue == null) ? rehashValue : THROW_CCE());
          var inductionVariable_0 = 0;
          var last_0 = this.p4n_1;
          if (inductionVariable_0 < last_0)
            $l$loop_0: do {
              var i_0 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              if (this.o4n_1[i_0] === oldRehashIndex) {
                this.o4n_1[i_0] = newIndex;
                break $l$loop_0;
              }
            }
             while (inductionVariable_0 < last_0);
          nextIndex = (nextIndex + 1 | 0) & (this.l4n_1.length - 1 | 0);
        }
        return oldValue;
      }
      y4(key) {
        if (!(!(key == null) ? typeof key === 'string' : false))
          return null;
        return this.t4n((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
      }
      v4() {
        var tmp0_elvis_lhs = this.q4n_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = KeySet().c4o(this);
          this.q4n_1 = this_0;
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      l3() {
        var tmp0_elvis_lhs = this.r4n_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = EntrySet().j4o(this);
          this.r4n_1 = this_0;
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      w4() {
        var tmp0_elvis_lhs = this.s4n_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = ValueCollection().g4o(this);
          this.s4n_1 = this_0;
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      equals(other) {
        if (other === this)
          return true;
        if (!(other instanceof CaseInsensitiveMap()))
          return false;
        if (!(other.q2() === this.n4n_1))
          return false;
        var inductionVariable = 0;
        var last = this.l4n_1.length - 1 | 0;
        if (inductionVariable <= last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var k = this.l4n_1[i];
            if (!(k == null)) {
              var v = this.m4n_1[i];
              if (!equals_0(other.k2o(k), v))
                return false;
            }
          }
           while (inductionVariable <= last);
        return true;
      }
      hashCode() {
        var result = 0;
        var inductionVariable = 0;
        var last = this.l4n_1.length - 1 | 0;
        if (inductionVariable <= last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var k = this.l4n_1[i];
            if (!(k == null)) {
              var tmp = result;
              var tmp_0 = caseInsensitiveHashCode(Companion_getInstance(), k);
              var tmp0_safe_receiver = this.m4n_1[i];
              var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
              result = tmp + (tmp_0 ^ (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs)) | 0;
            }
          }
           while (inductionVariable <= last);
        return result;
      }
    }
    initMetadataForClass($, 'CaseInsensitiveMap', CaseInsensitiveMap, VOID, [KtMutableMap()]);
    CaseInsensitiveMapClass = $;
  }
  return CaseInsensitiveMapClass;
}
//region block: exports
export {
  CaseInsensitiveMap as CaseInsensitiveMap3bv985x2xrppt,
};
//endregion

//# sourceMappingURL=CaseInsensitiveMap.mjs.map
